import { Checkbox } from '@/components/ui/checkbox';
import { Field, inputCls } from './fields';
import { inr } from '@/lib/loan';

function Group({ title, rows, edit, editLabel, testid }) {
  return (
    <div className="rounded-xl border border-white/10 bg-ink/60 p-5" data-testid={testid}>
      <div className="flex items-center justify-between">
        <p className="font-mono text-[11px] font-semibold uppercase tracking-[0.25em] text-pulse">{title}</p>
        <button type="button" onClick={edit} data-testid={`${testid}-edit`} className="text-xs font-semibold text-slate-400 hover:text-pulse">
          {editLabel}
        </button>
      </div>
      <div className="mt-3 grid gap-x-6 gap-y-2 sm:grid-cols-2">
        {rows.map(([label, value]) => (
          <div key={label} className="flex justify-between gap-4 text-sm">
            <span className="text-slate-500">{label}</span>
            <span className="text-right font-medium text-slate-200">{value}</span>
          </div>
        ))}
      </div>
    </div>
  );
}

export default function ApplyStepReview({ a, form, set, errors, t, onEditLoan, onEditPersonal }) {
  return (
    <div className="space-y-5" data-testid="apply-step-3">
      <Group
        title={a.loan}
        edit={onEditLoan}
        editLabel={a.edit}
        testid="step-3-review-loan"
        rows={[
          [t.apply.step1.amount, inr(form.amount)],
          [t.apply.step1.tenure, `${form.tenure_days} ${t.rates.days}`],
          [t.apply.step1.purpose, form.purpose],
          [t.apply.step2.employment, form.employment_type],
          [t.apply.step2.income, inr(form.monthly_income)],
          ['PAN', form.pan_number],
        ]}
      />
      <Group
        title={a.personal}
        edit={onEditPersonal}
        editLabel={a.edit}
        testid="step-3-review-personal"
        rows={[
          [t.apply.step2.name, form.full_name],
          [t.apply.step2.phone, form.phone],
          [t.apply.step2.email, form.email],
          ...(form.city ? [[t.apply.step2.city, form.city]] : []),
        ]}
      />

      <div className="rounded-xl border border-pulse/25 bg-ink/60 p-5" data-testid="step-3-bank">
        <p className="font-mono text-[11px] font-semibold uppercase tracking-[0.25em] text-pulse">{a.bank}</p>
        <div className="mt-4 grid gap-5 sm:grid-cols-3">
          <Field label={a.bankName} testid="step-3-bank-name" error={errors.bank_name}>
            <input
              data-testid="step-3-bank-name-input"
              className={inputCls}
              value={form.bank_name}
              onChange={(e) => set('bank_name', e.target.value)}
              placeholder="HDFC Bank"
              aria-label={a.bankName}
            />
          </Field>
          <Field label={a.account} testid="step-3-account" error={errors.account_number}>
            <input
              data-testid="step-3-account-input"
              className={inputCls}
              value={form.account_number}
              onChange={(e) => set('account_number', e.target.value.replace(/\D/g, ''))}
              placeholder='50100xxxxxx'
              inputMode="numeric"
              maxLength={18}
              aria-label={a.account}
            />
          </Field>
          <Field label={a.ifsc} testid="step-3-ifsc" error={errors.ifsc}>
            <input
              data-testid="step-3-ifsc-input"
              className={inputCls}
              value={form.ifsc}
              onChange={(e) => set('ifsc', e.target.value.toUpperCase())}
              placeholder="HDFC0001234"
              maxLength={11}
              aria-label={a.ifsc}
            />
          </Field>
        </div>
      </div>

      <div className="space-y-3" data-testid="step-3-consents">
        {a.consents.map((c, i) => (
          <label key={i} className="flex cursor-pointer items-start gap-3 rounded-xl border border-white/10 bg-ink/40 p-4 transition-colors hover:border-pulse/30">
            <Checkbox
              data-testid={`step-3-consent-${i}`}
              checked={form.consents[i]}
              onCheckedChange={(v) => set('consents', form.consents.map((x, j) => (j === i ? !!v : x)))}
              className="mt-0.5 border-slate-600 data-[state=checked]:border-pulse data-[state=checked]:bg-pulse data-[state=checked]:text-ink"
            />
            <span className="text-xs leading-relaxed text-slate-300">{c}</span>
          </label>
        ))}
        {errors.consents && (
          <p data-testid="step-3-consents-error" className="text-xs font-medium text-red-400">
            {errors.consents}
          </p>
        )}
      </div>
    </div>
  );
}
